import React, { Component } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    }
}));


//needed:doc only a message property is needed
//export function PlaceBid({message}){
//export function PlaceBid({message}){
const PlaceBid = props => {
//const PlaceBid = (message) => ({message}){
    const { classes } = useStyles();
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Text size="lg" className={classes.msg}>
                        {props.message}
                    </Text>
                </Card.Section>
                <br/>
                <NumberInput
                    placeholder="Enter Bid"
                    label="Bid Amt"
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    formatter={(value) => !Number.isNaN(parseFloat(value)) ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '$ '}
                    hideControls
                />
                <br/>
                <br/>
                <Button
                    color="green"
                    leftIcon={<IconCheck size={35} stroke={2.0}/>}
                    fullWidth
                ></Button>
            </Card>
        </>
    )
};
export default PlaceBid;
